module.exports = __webpack_public_path__ + "img/icon-knowledge.1abeac82.svg";